<span class="badge mw-100 {{ sizingTheme().badgeClass }} {{ colorScheme().backgroundClass }}" [attr.title]="text() | translate">
  <span [ngClass]="size() === 'micro' ? 'sr-only' : ''" class="d-flex overflow-hidden">
    @if (iconClass()) {
      <i class="{{ iconClass() }} {{ sizingTheme().iconMarginClass }} {{ colorScheme().iconColorClass }}" aria-hidden="true"></i>
    }
    @if (text()) {
      <span class="text-truncate" [ngClass]="colorScheme().textColorClass">
        {{ text() | translate }}
      </span>
    } @else {
      <span class="text-truncate" [ngClass]="colorScheme().textColorClass">
        <ng-content />
      </span>
    }
  </span>
</span>
